import { createContext } from 'react';

import { Ability } from './types';

export const AbilityContext = createContext<Ability>({} as never);
